// extracted by mini-css-extract-plugin
export var checkbox = "_5u-0";
export var circle = "_5u-3";
export var horizontalContainer = "_5u-7";
export var sm = "_5u-5";
export var switch0 = "_5u-2";
export var switchDisabled = "_5u-8";
export var switchEnabled = "_5u-1";
export var textSwitchContainer = "_5u-9";
export var textSwitchOption = "_5u-a";
export var textSwitchOptionSelected = "_5u-b";
export var verticalContainer = "_5u-6";
export var xs = "_5u-4";